import './index.css'
import pinPutih from '../../../assets/pin-1.svg'
import calendarPutih from '../../../assets/calendar-1.svg'
import { useNavigate } from "react-router-dom";

export const HomeTypeCard = ({gambar, judul, style, sisa, total, tanggal, jam, tempat, showJoinNow, fungsi}) => {
    const history = useNavigate()
    const handleToEventDetail = () => {
        fungsi()
        setTimeout(function() {
            history("/event/detailEvent");
       }, 500);
    }

    const handleJoinNow = () => {
        fungsi()
        setTimeout(function() {
            history("/event/detailEvent/setSchedule");
       }, 500);
    }

    return (
        <div className="kontainerCard">
            <div onClick={e => {handleToEventDetail()}} class="card">
                <div alt="gambarevent" style={{backgroundImage:`url(${gambar})`}} class="gambarEvent"></div>
                <div class="kontainerDetail">
                    <p class="judulEvent">{judul}</p>
                    <p class="foodstyle">{style}</p>
                    {
                        sisa <= 3 ?
                        <p class="seatleftred">{sisa} left seats</p>
                        :
                        <p class="seatleft">{sisa} left seats</p>
                    }
                    <p class="totalseat">from {total}</p>
                    <div class="kontainerjam">
                        <img src={calendarPutih} class="iconcard" alt="iconcard"></img>
                        <p class="kontainerjamtext">{tanggal}</p>
                        <p class="kontainerjamseparator">•</p>
                        <p class="kontainerjamtext">{jam}</p>
                    </div>
                    <div class="kontaineralamat">
                        <img src={pinPutih} class="iconcard" alt="iconcard"></img>
                        <p class="kontainerjamtext">{tempat}</p>
                    </div>
                </div>
                {
                    showJoinNow && (
                        <p onClick={e => {e.preventDefault();e.stopPropagation();handleJoinNow()}} className='HTCjoinnow small'>Join Now   →</p>
                    )
                }
                
            </div>
        </div>
    )
  }